import { forwardRef } from 'react';
import { Typography } from '../../../Typography/Typography.js';
import { getFormFieldLabelStyles } from './FieldLabelStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const FieldLabel = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    hasFocusedValue = false,
    children,
    isDisabled = false,
    ...rest
  } = props;
  return jsx(Typography, {
    bold: !hasFocusedValue,
    component: "label",
    variant: !hasFocusedValue ? 'body2' : 'small',
    css: getFormFieldLabelStyles(hasFocusedValue, isDisabled),
    ref: ref,
    ...rest,
    children: children
  });
});
FieldLabel.displayName = 'FieldLabel';

export { FieldLabel };
//# sourceMappingURL=FieldLabel.js.map
